import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, ParamMap, Route, Router } from '@angular/router';
import { SimpleSearch } from 'src/app/core/models/simple-search.model';
import { ApiResource } from '../models/api-resource.model';
import { UserService } from '../services/user.service';

@Component({
    selector: 'list-api-resources',
    templateUrl: './list-api-resources.component.html',
    standalone: false
})
export class ListApiResourcesComponent implements OnInit {

    public resources: ApiResource[];
    public isLoading: boolean = true;

    constructor(
        private route: ActivatedRoute,
        private userService: UserService) {
            this.resources = [];
    }

    ngOnInit(): void {

        this.route.queryParamMap
            .subscribe(params => {

                let search = new SimpleSearch();
                this.isLoading = true;
                
                this.userService.listApiResources(search)
                    .then(response => {
                        console.log('## Api Resources ##', response);
                        this.resources = response.resources;
                        this.isLoading = false;
                    }).catch(error => {
                    });
            });

    }

}



